import { useCallback, useMemo } from "react";
import { useAuthContext } from "../auth/useAuthContext";
import { formatCurrency, getCurrencySymbol } from "../utils/currency";

export default function useVenueCurrency() {
  const { user } = useAuthContext();
  const currency = useMemo(
    () =>
      user?.venue?.franchiseId?.currency || null,
    [user?.venue?.franchiseId?.currency]
  );
  const symbol = useMemo(() => getCurrencySymbol(currency), [currency]);
  const format = useCallback((amount, options) => formatCurrency(amount, currency, options), [currency]);

  return { currency, code: currency?.code || "", symbol, formatCurrency: format };
}
